import { useCallback, useEffect } from "react";
import FilterContent from "../../../../components/Filter/FilterContent";
import {
  useLeadsContainerStore,
  useLeadsStore,
} from "../../../../stores/LeadsStore";
import { useProfileStore } from "../../../../stores/UserStore";
import PopOver from "../../../../components/View/PopOver";
import { IconAdjustmentsHorizontal, IconX } from "@tabler/icons-react";
import { Button, Group, Indicator, Tooltip } from "@mantine/core";
import { useLanguage } from "../../../../stores/LanguageStore";

const LeadsFilter = () => {
  const lang = useLanguage((s) => s.language);
  const filter = useLeadsStore((s) => s.filter);
  const filters = useLeadsStore((s) => s.filters);
  const setFilter = useLeadsStore((s) => s.setFilter);
  const setReloadAll = useLeadsContainerStore((s) => s.setReloadAll);

  const profile = useProfileStore((s) => s.profile);

  const handleFilter = useCallback(
    (newFilter) => {
      setFilter(newFilter);
      setReloadAll(true);
    },
    [setFilter, setReloadAll]
  );

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    let prog = urlParams.get("programmation_id");
    let created_on = urlParams.get("created_on");
    let contact_type = urlParams.get("contact_type");
    let contact_id = urlParams.get("contact_id");
    let defaultFilter = urlParams.get("filter") ? urlParams.get("filter") : filter?.values?.length > 0 ? JSON.stringify(filter) : null;

    if (prog && created_on) {
      let v = [
        {
          field_name: "programmation_id",
          type: "equals",
          value: prog,
        },
      ];
      if (contact_type) {
        v.push({
          field_name: contact_type,
          type: "more_than",
          value: created_on,
        });
      }

      setFilter({
        mode: "and",
        values: v,
      });
    } else {
      if (contact_id) {
        setFilter({
          mode: "and",
          values: [
            {
              field_name: "id",
              type: "equals",
              value: contact_id,
            },
          ],
        });
      } else {
        if (defaultFilter) {
          setFilter(JSON.parse(defaultFilter));
        } else {
          setFilter(
            profile?.saved_filters?.prm?.find((x) => x?.pinned === true)
              ?.filter || null
          );
        }
      }
    }
  }, []);

  return (
    <Group gap={0} mr={16}>
      <PopOver
        opener={(openFunction, ref) => {
          return (
            <Group gap={0}>
              <Tooltip label={lang.table.toolbar.filter.main_button_tooltip}>
                <Button
                  ref={ref}
                  onClick={openFunction}
                  radius={"md"}
                  variant={"subtle"}
                  className="test"
                  style={{
                    borderColor: "var(--mantine-color-primary-0)",
                    background: "#fff",
                    borderTopRightRadius: filter?.values?.length > 0 ? 0 : 8,
                    borderBottomRightRadius: filter?.values?.length > 0 ? 0 : 8,
                  }}
                  id={"table-filter-prm"}
                >
                  <Indicator
                    color="red"
                    offset={2}
                    disabled={!filter || filter?.values?.length === 0}
                    label={filter?.values?.length}
                    styles={{
                      indicator: {
                        fontSize: 9,
                        padding: "6px",
                      },
                    }}
                  >
                    <IconAdjustmentsHorizontal size={20} />
                  </Indicator>
                  <span style={{ marginLeft: 6 }}>
                    {lang.table.toolbar.filter.main_button_label}
                  </span>
                </Button>
              </Tooltip>
              {filter?.values?.length > 0 && (
                <Tooltip
                  label={lang.table.toolbar.filter.cancel_button_tooltip}
                >
                  <Button
                    variant="light"
                    color="red"
                    px={4}
                    style={{
                      borderLeft: "none",
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                    }}
                    onClick={() => handleFilter(null)}
                  >
                    <IconX size={18} />
                  </Button>
                </Tooltip>
              )}
            </Group>
          );
        }}
        popoverChildren={(handleClose) => (
          <FilterContent
            id={"prm-filter"}
            isClient={false}
            pageName={"prm"}
            mainFilter={filter}
            setMainFilter={(newFilter) => {
              handleFilter(newFilter);
              handleClose();
            }}
            fields={filters}
            getFieldOptionName={(f) => f.option_name}
          // defaultFiltersClose={true}
          />
        )}
        elevation={3}
        paperSx={{
          ml: -12,
        }}
      />
    </Group>
  );
};

export default LeadsFilter;
